/*
 * Title: 수당 조회
 * Author: hskim (taeoh.kim@gentlepie.com )
 */

/*
2025.2 - 수당 발생이력
"example": {
  "request": "GET https://oadev.atomyn.com/chatbotSponsorshipAllowance",  // 샘플 요청 URL
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-17T11:13:42.001423300+09:00[Asia/Seoul]",  // 응답 시간
    "item": {
      "Data": [
        {
          "TotalCount": "1",  // 전체 데이터 개수
          "Date": "2024-05-23",  // 수당 발생 날짜
          "DealershipCode": "3",  // 등급 코드
          "BasicPv": "1547476",  // 보유 PV
          "CurGradeCode": "00",  // 현재 등급 코드
          "YoujiGradeCode": "07",  // 유지 등급 코드
          "HuwonBonus": "0",  // 후원 수당 금액
          "Score": "0",  // 취득 점수
          "Left": {  // 좌측 매출 정보
            "YesterdayPv": "464300",  // 좌측 전일 매출 PV
            "TodayPv": "13100",  // 좌측 금일 매출 PV
            "AccumulatedPv": "452478473",  // 좌측 누적 매출 PV
            "TransferPv": "477400"  // 좌측 이월 매출 PV
          },
          "Right": {  // 우측 매출 정보
            "YesterdayPv": "247700",  // 우측 전일 매출 PV
            "TodayPv": "22700",  // 우측 금일 매출 PV
            "AccumulatedPv": "191963236",  // 우측 누적 매출 PV
            "TransferPv": "270400"  // 우측 이월 매출 PV
          }
        }
      ]
    }
  }
}
*/

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleProxy from '../common/proxy';
import GentleServiceSales from './sales';
import GentleAppState from '../common/appstate';
import language from '../lang';

const lang = 'KR';

var GentleServiceBonus = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})
function leftPad(value) {
    if (value >= 10) {
        return value;
    }else{
        return `0${value}`;

    }

}

// 수당 조회 
// 2025.3 수당 조회 : 확인
GentleServiceBonus.main = function(){
    const name = GentleAppState.custName;

    console.log('GentleServiceBonus.main');
    const component =  Object.create(this);

    console.log('GentleAppState>', GentleAppState);

    // element 참조 변수 선언
    const cards = [];
    let $list;  // 목록
    let curPage = 0;

    let today = new Date();   
    console.log("today =>", today)
    let year = today.getFullYear(); // 년도
    console.log("today.getFullYear =>", today.getFullYear())

    let month = leftPad(today.getMonth() + 1);  // 월
    console.log("today.getMonth =>", today.getMonth())

    let date = leftPad(today.getDate());  // 날짜
    console.log("today.getDate() =>", today)


    let startDate = ""
    let endDate = ""
    // alert(year + '-' + month + '-' + date)
    let endMonthDay = new Date(year, month, 0).getDate()
    if(date < 14){
        startDate = year + '-' + month + '-' + "01"
        endDate = year + '-' + month + '-' + "14"
    }else{
        startDate = year + '-' + month + '-' + "15"
        endDate = year + '-' + month + '-' + endMonthDay
    }
    console.log("현재의 날짜는" + month + '-' + date + "이며, \n" + "정산기간은 " + startDate + "부터" + endDate + "까지입니다." )


    // 최근 1건만 조회
    const request = function(PageNo, PageSize, StartDate, EndDate){
         StartDate = startDate
         EndDate = endDate
        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                const { Data } = item;
                console.log('Data>', Data);
                
                if(Data && Data.length > 0){
                    render(Data);
                }else{
                    const today = new Date();
                    const date = today.toLocaleDateString();
                    let html = GentleLang.translateService(language.bonus, language.bonus.type.NothingIncome, {name, date})

                    const button_title = GentleLang.translateService(language.bonus, language.bonus.type.More);

                    let redirectUrl = (GentleAppState.isPc) ? (language.url.pc.ViewMoreBenefits) : (language.url.mobile.ViewMoreBenefits);
                    
                    const option = [
                        {
                            send: false,
                            isSecondary: true,
                            isCardWidth: true,
                            text: button_title,
                            user: 'user',
                            onClick: function(){
                                console.log('더보기');
                                GentleUtil.ssoOpen(redirectUrl);
                                // request(curPage + 1);
                            },
                        },
                    ]
                    let bubble = Object.create( GentleComponentBubble );   
                    let button = Object.create(GentleComponentButton);
                    button.createComponent(option)
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();
                    button.insert();
                }    
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {PageNo, PageSize, StartDate:"2024-01-01", EndDate}; // test

        console.log("params", param);
        // proxy.request("global-bonus", param, onSuccess, onFailed );
        proxy.request("2025-bonus", param, onSuccess, onFailed );
    }

    const render = function(array){
        // 최근 후원수당, 직급수당을 가져오기
        let huwonData = null, levelData = null;
        {
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                {
                    const {HuwonBonus, LevelBonus} = element;
                    if(huwonData == null && HuwonBonus > 0){
                        huwonData = element;
                    }
        
                    if(levelData == null && LevelBonus > 0){
                        levelData = element;
                    }
        
                    if(huwonData && levelData) break;
                }
            }
        }
        console.log('후원수당/직급수당', {huwonData, levelData});

        // 봇버블
        {
            const html = GentleLang.translateService(language.bonus, language.bonus.type.Bot, {name});
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const titleButton = GentleLang.translateService(language.bonus, language.bonus.type.RecentDetail);
            const titleTotal = GentleLang.translateService(language.bonus, language.bonus.type.Total);
            const titlePosition = GentleLang.translateService(language.bonus, language.bonus.type.PositionPay);
            const titleSpon = GentleLang.translateService(language.bonus, language.bonus.type.SponPay);

            // 후원수당 
            const sponDate = GentleLang.translateService(language.bonus, language.bonus.type.DateFormat, {date: huwonData.PayDate});
            const sponValue = GentleLang.translate(GentleLang.type.CurrencyFormat2, {num: GentleUtil.comma(huwonData.HuwonBonus)});

            // 직급수당
            let htmlPositon = '';
            let positionDate;
            let positionValue;
            if(levelData){
                positionDate = GentleLang.translateService(language.bonus, language.bonus.type.DateFormat, {date: levelData.PayDate});
                positionValue = GentleLang.translate(GentleLang.type.CurrencyFormat2, {num: GentleUtil.comma(levelData.LevelBonus)});

                htmlPositon = `
                <p><span class="time-label">${positionDate}</span></p>
                <div class="flex-box-2 center">
                    <span><strong>${titlePosition}</strong></span>
                    <span>${positionValue}</span>
                </div>
                `
            }
            else{
                console.log('levelData 없슴 - 직급내역 없슴');
            }

            let html = `
            <div class="card-view">
                <div class="recently-pay-container">
                    <div class="account-box">
                        <p><span class="time-label">${sponDate}</span></p>
                        <div class="flex-box-2 center">
                            <span><strong>${titleSpon}</strong></span>
                            <span>${sponValue}</span>
                        </div>
                        ${htmlPositon}
                        <div class="gentle-button-group">
                            <div class="wide-button">
                                <button type="button" class="primary default">${titleButton}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            `

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("payment");
                component.init($container);
                component.insert();
            }

            // button
            component.find('button').bind('click',function() {
                    console.log('최근수당 내역 자세히 보기');

                    GentleServiceBonus.popupRecentDetail({huwonData, levelData});
                }
            );
        }

        // button
        {
            // 매출보기
            const text = GentleLang.translateService(language.bonus, language.bonus.type.ShowSales);
            const option = [
                {
                    isSecondary: true,
                    isCardWidth: true,
                    text: text,
                    user: 'user',
                    // onClick: function () {
                    //     console.log(text);
                    //     GentleComponentBubble.insertUserBubble({html});
                    // },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }

        // quickReplay
        {
            const buttons = [
                {
                    // send: false,
                    title: GentleLang.translateService(language.bonus, language.bonus.type.SponPay),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.SponPay),
                    onClick: function() {
                        console.log('후원수당');
                        // GentleServiceBonus.huwonBonus();
                    }
                },
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                    onClick: function() {
                        console.log('후원수당 발생내역');
                        // GentleServiceBonus.huwonBonusOccurrence();
                    }
                },
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.PositonPayDetail),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.PositonPayDetail),
                    onClick: function() {
                        console.log('직급내역');
                        // GentleServiceBonus.positionPay();
                    }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };
    
    request(1, 1, '', ''); //(PageNo, PageSize, StartDate, EndDate)
}

// 최근 수당내역 자세히 보기
GentleServiceBonus.popupRecentDetail = function(data){
    console.log('GentleServiceBonus.popupRecentDetail', data);
    //20221017
    // GentleUtil.updateSSOToken();

    let {huwonData, levelData} = data;

    // levelData = levelData ? levelData : {}; // 안오는 경우가 있다.

    const render = function(data){
        const title = GentleLang.translateService(language.bonus, language.bonus.type.RecentDetail);
        const titleTotal = GentleLang.translateService(language.bonus, language.bonus.type.Total);
        // const total = GentleLang.translate(GentleLang.type.CurrencyFormat3, {num: GentleUtil.comma('999999999')});

        ////////// 후원수당
        const titleSpon = GentleLang.translateService(language.bonus, language.bonus.type.SponPay);
        // 실수령액
        const titleSponReal = GentleLang.translateService(language.bonus, language.bonus.type.Total);
        // 소득세
        const titleSponTaxs = GentleLang.translateService(language.bonus, language.bonus.type.TaxS);
        // 주민세
        const titleSponTaxj = GentleLang.translateService(language.bonus, language.bonus.type.TaxJ);
        // 입금계좌
        const titleSponAccount = GentleLang.translateService(language.bonus, language.bonus.type.Account);
        // 계좌 소유주
        const titleSponName = GentleLang.translateService(language.bonus, language.bonus.type.AccountName);
        ////////////////// 직급수당
        const titlePosition = GentleLang.translateService(language.bonus, language.bonus.type.PositionPay);

        const button_title = GentleLang.translateService(language.bonus, language.bonus.type.More);

        ////////// 후원수당
        // let {PayDate, LevelBonus, TaxAmt1, TaxAmt2, RealAmt} = huwonData;
        const sponDate = GentleLang.translateService(language.bonus, language.bonus.type.DateFormat, {date: huwonData.PayDate});

        const sponValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(huwonData.HuwonBonus)});
        // 실수령액
        const sponRealValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(huwonData.RealAmt)});
        // 소득세
        const sponTaxsValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(huwonData.TaxAmt1)});
        // 주민세
        const sponTaxjValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(huwonData.TaxAmt2)});

        const {BankAccountInfo: BankAccountInfoHuwon} = huwonData;

        let html = `
        <div id="sales-container" class="pay">
            <ul>
                <li>
                    <span class="time-label">${sponDate}</span>
                    <div class="flex-box space-between">
                        <span><strong class="bold">${titleSpon}</strong></span>
                        <span>
                            ${sponValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong class="bold">${titleSponReal}</strong></span>
                        <span>
                            ${sponRealValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponTaxs}</strong></span>
                        <span>
                            ${sponTaxsValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponTaxj}</strong></span>
                        <span>
                            ${sponTaxjValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponAccount}</strong></span>
                        <span>${BankAccountInfoHuwon.BankName} ${BankAccountInfoHuwon.AccountNo}</span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponName}</strong></span>
                        <span>
                            ${BankAccountInfoHuwon.AccountOwner}
                        </span>
                    </div>
                </li>
                `;

            if(levelData)
            {
                ///////// data binding
                ////////////////// 직급수당
                const positionDate = GentleLang.translateService(language.bonus, language.bonus.type.DateFormat, {date: levelData.PayDate});
                const positionValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(levelData.LevelBonus)});
                // 소득세
                const positionTaxsValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(levelData.TaxAmt1)});
                // 주민세
                const positionTaxjValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(levelData.TaxAmt2)});
                // 실수령액
                const positionRealValue = GentleLang.translate(GentleLang.type.CurrencyFormat, {num: GentleUtil.comma(levelData.RealAmt)});

                let {BankAccountInfo: BankAccountInfoLevel} = levelData;
                BankAccountInfoLevel = BankAccountInfoLevel ? BankAccountInfoLevel : {};

                html +=
                `<li>
                    <span class="time-label">${positionDate}</span>
                    <div class="flex-box space-between">
                        <span><strong class="bold">${titlePosition}</strong></span>
                        <span>
                            ${positionValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong class="bold">${titleSponReal}</strong></span>
                        <span>
                            ${positionRealValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponTaxs}</strong></span>
                        <span>
                            ${positionTaxsValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponTaxj}</strong></span>
                        <span>
                            ${positionTaxjValue}
                        </span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponAccount}</strong></span>
                        <span>${BankAccountInfoLevel.BankName} ${BankAccountInfoLevel.AccountNo}</span>
                    </div>
                    <div class="flex-box space-between">
                        <span><strong>${titleSponName}</strong></span>
                        <span>
                            ${BankAccountInfoLevel.OwnerName}
                        </span>
                    </div>
                </li>`;
            }

            html += `</ul>
            <div id="fixed-bottom-layer">
            <div class="gentle-button-group margin-zero">
                <div class="wide-button">
                <button type="button" class="big square primary default">${button_title}</button>
                </div>
            </div>
            </div>
        </div>
        `;

        let $container = $(html)
        // button
        console.log("direct > ", language.url.pc.ViewMoreBenefits);
        $container.find('button').bind('click',function(){
            console.log('더 많은 수당내역 보기 > 웹');
            var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.ViewMoreBenefits) : (language.url.mobile.ViewMoreBenefits);
                GentleUtil.ssoOpen(redirectUrl);
        });
        GentleUtil.createSlidePopup({title, content:$container});

    };
    render(data);
}

// 후원수당
GentleServiceBonus.huwonBonus = function(data){
    console.log('GentleServiceBonus.huwonBonus');
    const component =  Object.create(this);

    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }

    const simple = data.simple ? data.simple : false;
    let today = new Date();   

    let year = today.getFullYear(); // 년도
    let month = leftPad(today.getMonth() + 1);  // 월
    console.log("today.getMonth =>", today.getMonth())

    let date = leftPad(today.getDate());  // 날짜
    console.log("today.getDate() =>", today)
    let day = today.getDay();  // 요일
    let startDate = ""
    let endDate = ""
    // alert(year + '-' + month + '-' + date)
    let endMonthDay = new Date(year, month, 0).getDate()
    if(date < 14){
        startDate = year + '-' + month + '-' + "01"
        endDate = year + '-' + month + '-' + "14"
    }else{
        startDate = year + '-' + month + '-' + "15"
        endDate = year + '-' + month + '-' + endMonthDay
    }
    console.log("현재의 날짜는" + month + '-' + date + "이며, \n" + "정산기간은 " + startDate + "부터" + endDate + "까지입니다." )
    // api
    const request = function(){
        
        const pageSize = 5;

        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                const { Data } = item;
                console.log('Data>', Data);
                
                if(Data.length > 0){
                    render(Data);
                }
                else{
                    console.log('데이터 없슴');
                    const n = 3;
                    const html = GentleLang.translateService(language.bonus, language.bonus.type.NoHuwon, {n});
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();        
                }
    
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        let PageNo='', PageSize='', StartDate=startDate, EndDate=endDate;

        const proxy = Object.create(GentleProxy);
        const param = {PageNo, PageSize, StartDate, EndDate};

        proxy.request("global-huwonbonus", param, onSuccess, onFailed );
    }
    request();

    const render = function(array){ //Data
        // 후원수당목록
        console.log(array);

        if(!simple)
        {
            const {custName:name} = GentleAppState;            
            const html = GentleLang.translateService(language.bonus, language.bonus.type.SponsorBot, {name});
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const title = GentleLang.translateService(language.bonus, language.bonus.type.SponsorTitle);
            const titleSmall = GentleLang.translate(GentleLang.type.SmallSales);
            const left = GentleLang.translate(GentleLang.type.Left);
            const right = GentleLang.translate(GentleLang.type.Right);
            const Score = GentleLang.translateService(language.bonus, language.bonus.type.Score)
            // const { Left, Right } = data;

            ///// data binding : 
            const hour = '08';

            let date1 = array[0].Date; // '3월12일';    // Yesterday

            let date2 = ''; 
            if(array[1])
                date2 = array[1].Date;    // Today

            let date3 = ''; 
            if(array[2])
                date3 = array[2].Date;

            let html = `
            <div class="card-view">
                <div class="margin-container">
                    <h3>${title}</h3>
                    <span class="time-label" name="time-label"></span>
                    <div class="flex-box-2 space-beetween">
                        <span>${Score}</span>
                        <span><strong name="score"></strong></span>
                    </div>
                </div>
            
                <ul class="date-tab">
                    <li class="active" name="date1">${date1}</li>
                    <li name="date2">${date2}</li>
                    <li name="date3">${date3}</li>
                </ul>
                <div class="account-box" style="margin-top:0">
                    <div class="flex-box-2 center">
                        <div>
                            <strong>${left}</strong>
                            <hr class="mt-8">
                            <strong><em name="left"></em> PV</strong>
                        </div>
                        <div>
                            <strong>${right}</strong>
                            <hr class="mt-8">
                            <strong><em name="right"></em> PV</strong>
                        </div>
                    </div>
                    <div class="flex-box-2 space-beetween">
                        <span><strong>${titleSmall}</strong></span>
                        <span><strong name="small"></strong> PV</span>
                    </div>
                </div>
            </div>            
            `

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("sales");
                component.init($container);
                component.insert();
            }

            // bind
            {
                const $left = component.find('[name="left"]');
                const $right = component.find('[name="right"]');
                const $small = component.find('[name="small"]');
                const $score = component.find('[name="score"]');
                const $date1 = component.find('[name="date1"]');
                const $date2 = component.find('[name="date2"]');
                const $date3 = component.find('[name="date3"]');

                const $baseTime = component.find('[name="time-label"]');

                GentleProxy.requestBaseTime(function(date){
                    const str = GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date});
                    $baseTime.html(str);
                })

                const update = function(data){
                    let {Left, Right, Score} = data;
                    let leftPV = Number(Left.TodayPv);
                    
                    // 우
                    let rightPV = Number(Right.TodayPv);

                    // 소실적
                    // let valueSmall = Math.abs(leftPV - rightPV);
                    let valueSmall = leftPV < rightPV ? leftPV : rightPV;

                    $left.html(GentleUtil.comma(leftPV));     
                    $right.html(GentleUtil.comma(rightPV));  
                    $small.html(GentleUtil.comma(valueSmall));   
                    $score.html(GentleUtil.comma(Score));   
                }    

                // 1구간 셋팅
                update(array[0]);

                const active = function($target){
                    $date1.removeClass('active');
                    $date2.removeClass('active');
                    $date3.removeClass('active');

                    $target.addClass('active');
                }

                $date1.bind('click',function() {                    
                    active($date1);
                    update(array[0]);
                });
                $date2.bind('click',function() {
                    if(array[1]){
                        active($date2);
                        update(array[1]);
                    }
                });
                $date3.bind('click',function() {
                    if(array[2]){
                        active($date3);
                        update(array[2]);
                    }
                });
            }
        }

        // quickReplay
        const buttons = [];
        buttons.push({
            title: GentleLang.translateService(language.sale, language.sale.type.Recommend),
            text: GentleLang.translateService(language.sale, language.sale.type.Recommend),
            onClick: function() {
                console.log('소실적 맞춤 상품 추천');
                // GentleServiceSales.recommend();
            }
        });

        if(!simple){
            buttons.push({
                title: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                text: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                onClick: function() {
                    console.log('후원수당 발생내역');
                    // GentleServiceBonus.huwonBonusOccurrence();
                }
            });    
        }

        var quickReply = Object.create( GentleComponentQuickReply);   
        quickReply.createComponent(buttons);
        quickReply.insert();

        GentleUtil.timeStamp();
    };
}

// 후원수당 발생내역
GentleServiceBonus.huwonBonusOccurrence = function(){
    console.log('GentleServiceBonus.huwonBonusOccurrence');
    //20221017
    // GentleUtil.updateSSOToken();
    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }

    const component =  Object.create(this);
    let today = new Date();   

    let year = today.getFullYear(); // 년도
    let month = leftPad(today.getMonth() + 1);  // 월
    console.log("today.getMonth =>", today.getMonth())

    let date = leftPad(today.getDate());  // 날짜
    console.log("today.getDate() =>", today)
    let day = today.getDay();  // 요일
    let startDate = ""
    let endDate = ""
    // alert(year + '-' + month + '-' + date)
    let endMonthDay = new Date(year, month, 0).getDate()
    if(date < 14){
        startDate = year + '-' + month + '-' + "01"
        endDate = year + '-' + month + '-' + "14"
    }else{
        startDate = year + '-' + month + '-' + "15"
        endDate = year + '-' + month + '-' + endMonthDay
    }
    console.log("현재의 날짜는" + month + '-' + date + "이며, \n" + "정산기간은 " + startDate + "부터" + endDate + "까지입니다." )

    // api
    const request = function(){
        const pageSize = 5;
        let StartDate = startDate
        let EndDate = endDate
        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                const { Data } = item;
                console.log('Data>', Data);
    
                if(Data && Data.length > 0)
                {
                    render(Data);
                }
                else{
                    // todo : 업슴
                }
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {PageNo:'', PageSize:'', StartDate:startDate, EndDate:endDate};

        proxy.request("global-huwonbonus", param, onSuccess, onFailed );
    }
    request();

    const render = function(data){
        console.log(data);
        const recent = data[0];
        const recentDate = GentleUtil.dateString(data[0].Date);
        // 봇버블
        {
            const html = GentleLang.translateService(language.bonus, language.bonus.type.OccurBot);
            var bubble = Object.create( GentleComponentBubble );
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        {
            const titleScore  = GentleLang.translateService(language.bonus, language.bonus.type.Score);
            const titlePosition  = GentleLang.translateService(language.bonus, language.bonus.type.AquPositon);
            const titleButton = GentleLang.translateService(language.bonus, language.bonus.type.OccurDetail);
            // todo
            let {Score: score} = recent;
            score = GentleLang.translateService(language.bonus, language.bonus.type.ScoreFormat, {score});

            let html = `
            <div class="card-view">
                <div class="support-container">
                    <span class="time-label"></span>
                    <div class="flex-box-2 space-beetween">
                        <span>${recentDate}</span>
                        <span>${titleScore}</span>
                        <span><strong>${score}</strong></span>
                    </div>
                    
                    <hr class="mt-20">
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">${titleButton}</button>
                        </div>
                    </div>
                </div>
            </div>
            `;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("search");
                component.init($container);
                component.insert();
            }

            let baseTime;
            // bind
            {
                const $baseTime = component.find('.time-label');
                GentleProxy.requestBaseTime(function(date){
                    console.log(date);
                    baseTime = GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date});
                    $baseTime.html(baseTime);
                })
            }

            // button
            component.find('button').bind('click',function() {
                    console.log('후원수당 발생내역 자세히 보기');
                    GentleServiceBonus.huwonBonusOccurrenceDetail(data, baseTime);
                }
            );
        }

        // button
        {
            const text = GentleLang.translateService(language.bonus, language.bonus.type.Detail);
            const option = [
                {
                    // send: false, 인텐트 처리
                    text: text,
                    user: 'user',
                    // onClick: function () {
                    //     console.log(text);  // 인텐트 처리
                    //     // GentleServiceBonus.main();
                    // },
                },
            ]
            var button = Object.create(GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }

        // quickReplay
        {
            const buttons = [
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.PositonPayDetail),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.PositonPayDetail),
                    onClick: function() {
                        console.log('직급내역');
                        // GentleServiceBonus.positionPay();
                    }
                },
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.SaleList),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.SaleList),
                    onClick: function() {
                        console.log('매출조회');
                        // GentleServiceSales.main();
                    }
                },
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.Others),
                    send: false,
                    onClick: function() {
                        console.log('타기간 후원수당 발생내역');
                        var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.GeneralCommissionOther) : (language.url.mobile.GeneralCommissionOther);
                        GentleUtil.ssoOpen(redirectUrl);
                    }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };
}

// 후원수당 발생내역 자세히 보기
GentleServiceBonus.huwonBonusOccurrenceDetail= function(data, baseTime){
    console.log('GentleServiceBonus.huwonBonusOccurrenceDetail>');
    //20221017
    // GentleUtil.updateSSOToken();

    let $input_search;  // 검색 입력필드

    const render = function(data){
        console.log('render>', data);
        let row = data[0];
        console.log('row>', row);
        
        const {Left, Right, Date, Score, BasicPv} = row;
        
        const title = GentleLang.translateService(language.bonus, language.bonus.type.OccurDetail);
        const left = GentleLang.translate(GentleLang.type.Left);
        const right = GentleLang.translate(GentleLang.type.Right);
        const titleScore = GentleLang.translateService(language.bonus, language.bonus.type.Score);
        // const titlePosition = GentleLang.translateService(language.bonus, language.bonus.type.AquPositon);
        const titlePV = GentleLang.translateService(language.bonus, language.bonus.type.HoldPv);
        const titleTotal = GentleLang.translate(GentleLang.type.Total);
        const titleToday = GentleLang.translate(GentleLang.type.TodaySales);
        const titleYesterday = GentleLang.translate(GentleLang.type.YesterdaySales);

        // const titleHoldover = GentleLang.translate(GentleLang.type.Holdover);
        const titleSales = GentleLang.translateService(language.bonus, language.bonus.type.TitleSales);

        const titleButton = GentleLang.translateService(language.bonus, language.bonus.type.SponDetailMore);

        // 취득점수
        const score = GentleLang.translateService(language.bonus, language.bonus.type.ScoreFormat, {score: Score});
        const scoreDate = row.Date;
        // 보유PV
        let myPv = GentleUtil.comma(BasicPv);

        // todo : HuwonBonusLowerItem.YesterdayPv + HuwonBonusLowerItem.TodayPv

        const compareTotal = GentleUtil.compareImage(totalLeft, totalRight);
        totalLeft = GentleUtil.comma(totalLeft);
        totalRight = GentleUtil.comma(totalRight);
        
        // 매출
        let transferPvLeft = Left.TransferPv;
        let transferPvRight = Right.TransferPv;
        const compareHoldover = GentleUtil.compareImage(transferPvLeft, transferPvRight);
        transferPvLeft = GentleUtil.comma(transferPvLeft);
        transferPvRight = GentleUtil.comma(transferPvRight);

        // 오늘
        let todayLeft = Left.TodayPv;
        let todayRight = Right.TodayPv;
        const compareToday = GentleUtil.compareImage(todayLeft, todayRight);

        // 어제
        let yesterdayLeft = Left.YesterdayPv;
        let yesterdayRight = Right.YesterdayPv;
        const compareYesterday = GentleUtil.compareImage(yesterdayLeft, yesterdayRight);

        // 합계
        let totalLeft = yesterdayLeft + todayLeft;
        let totalRight = yesterdayRight + todayRight;

        // const total = GentleLang.translateService(language.account, language.account.type.TotalIndex, {count: data.count, total: data.total});
        //// end of bind

        let html = `
        <div id="sales-container" class="huwon">
            <div class="sales-summary">
                <span class="time-label">${baseTime}</span>
                    <div class="flex-box space-between">
                        <span>${scoreDate}</span>
                        <span><strong>${titleScore}</strong></span>
                        <span>
                            <strong class="bold">${score}</strong>
                        </span>
                    </div>
                    
                </div>
                <ul>
                    <li>
                        <h6>${titleYesterday}</h6>
                        <div class="flex-box center">
                            <div>
                                <strong class="bold">${left}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(yesterdayLeft)}</em> PV</strong>
                            </div>
                            
                            <div>
                                <strong class="bold">${right}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(yesterdayRight)}</em> PV</strong>
                            </div>
                        </div>  
                    </li>
                    <li>
                        <h6>${titleToday}</h6>
                        <div class="flex-box center">
                            <div>
                                <strong class="bold">${left}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(todayLeft)}</em> PV</strong>
                            </div>
                            
                            <div>
                                <strong class="bold">${right}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(todayRight)}</em> PV</strong>
                            </div>
                        </div>  
                    </li>
                    <li>
                        <h6>${titleTotal}</h6>
                        <div class="flex-box center">
                            <div>
                                <strong class="bold">${left}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(totalLeft)}</em> PV</strong>
                            </div>
                            
                            <div>
                                <strong class="bold">${right}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${GentleUtil.comma(totalRight)}</em> PV</strong>
                            </div>
                        </div>  
                    </li>
                    <li>
                        <h6>${titleSales} PV</h6>
                        <div class="flex-box center">                            
                            <div>
                                <strong class="bold">${left}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${transferPvLeft}</em> PV</strong>
                            </div>
                            
                            <div>
                                <strong class="bold">${right}</strong>
                                <hr class="mt-8">
                                <strong><em class="pv">${transferPvRight}</em> PV</strong>
                            </div>
                        </div>  
                    </li>                    
                </ul>
                <div id="fixed-bottom-layer">
                <div class="gentle-button-group margin-zero">
                    <div class="wide-button">
                    <button type="button" class="big square primary default">${titleButton}</button>
                    </div>
                </div>
                </div>
        </div>            `

        let $container = $(html)

        // 검색버튼
        {
            $input_search = $container.find('input');
            $input_search.keydown(function(key) {
                if (key.keyCode == 13) {
                    const text = $input_search.val();
                    doSearch(text);
                    $input_search.val('');
                    $input_search.attr("readonly",true);
                    $input_search.focus();
                    setTimeout(function(){ $input_search.attr("readonly",false);}, 50);
                }
            });
        }

        // button
        $container.find('button').bind('click',function() {
                console.log('더 많은 후원수당 발생내역 보기 > 웹');
                var redirectUrl = (GentleAppState.isPc) ? (language.url.pc.ViewMoreGeneralHistory) : (language.url.mobile.ViewMoreGeneralHistory);
                    GentleUtil.ssoOpen(redirectUrl);
            }
        );
        
        GentleUtil.createSlidePopup({title, content: $container});
    };

    render(data);
}

// 직급내역
/* 
2025.2 - 직급 이력
"example": {
  "request": {
    "method": "GET",
    "url": "https://oadev.atomyn.com/chatbotLevelHistory",
    "headers": {
      "user-token": "{user-token}"  // 사용자 인증 토큰
    },
    "parameters": {
      "startDate": "2020-01-01",  // 조회 시작일자 (기본값: 현재일자)
      "endDate": "2025-02-17",  // 조회 종료일자 (기본값: 현재일자)
      "SearchSalesMasterAchievement": "1"  // 직급 달성 여부 조회 (1: 조회, 기타: 미조회)
    }
  },
  "response": {
    "result": "200",  // 응답 코드 (성공)
    "resultMessage": "SUCCESS",  // 응답 메시지
    "siteNo": "KR",  // 요청한 사이트 번호
    "locale": "ko_KR",  // 요청한 사이트 언어 및 번호
    "time": "2025-02-17T12:42:59.237393200+09:00[Asia/Seoul]",  // 응답 시간
    "item": {
      "Data": {
        "MastershipAchievementItems": [  // 직급 달성 이력
          {
            "Date": "2020-02-15 00:00:00",  // 정산일자
            "CustNo": "S3574595",  // 회원번호
            "MastershipCode": "03"  // 직급 코드
          },
          {
            "Date": "2020-01-31 00:00:00",
            "CustNo": "S3574595",
            "MastershipCode": "02"
          },
          {
            "Date": "2020-01-15 00:00:00",
            "CustNo": "S3574595",
            "MastershipCode": "02"
          }
        ],
        "SalesMasterAchievementItems": [  // 판매 실적 이력
          {
            "Date": "2020-02-15 00:00:00",  // 정산일자
            "LeftPv": "6009520",  // 좌측 PV
            "RightPv": "2661840",  // 우측 PV
            "MinPv": "2661840",  // 소실적
            "BasicPv": "0",  // 본인 누적 PV
            "DealershipCode": "2",  // 등극 코드
            "MastershipCode": "03",  // 직급 코드
            "CustNo": "S3574595"  // 회원번호
          },
          {
            "Date": "2020-01-31 00:00:00",
            "LeftPv": "1962870",
            "RightPv": "1274150",
            "MinPv": "1274150",
            "BasicPv": "0",
            "DealershipCode": "3",
            "MastershipCode": "02",
            "CustNo": "S3574595"
          },
          {
            "Date": "2020-01-15 00:00:00",
            "LeftPv": "1679270",
            "RightPv": "1399890",
            "MinPv": "1399890",
            "BasicPv": "0",
            "DealershipCode": "3",
            "MastershipCode": "02",
            "CustNo": "S3574595"
          }
        ]
      }
    }
  }
}

*/
// 2025.3 직급내역 조회
// 바인딩은 확인완료. 
// 실제 유효한 데이터가 없어 동작확인은 못함
GentleServiceBonus.positionPay = function(json){
    console.log('GentleServiceBonus.positionPay');
    //20221017
    // GentleUtil.updateSSOToken();
    const component =  Object.create(this);

    const {completed} = json;
    const simple = json.simple ? json.simple : false;   // 디폴트는 false;

    let today = new Date();   

    let year = today.getFullYear(); // 년도
    let month = leftPad(today.getMonth() + 1);  // 월
    console.log("today.getMonth =>", today.getMonth())

    let date = leftPad(today.getDate());  // 날짜
    console.log("today.getDate() =>", today)
    let day = today.getDay();  // 요일
    let startDate = ""
    let endDate = ""
    // alert(year + '-' + month + '-' + date)
    let endMonthDay = new Date(year, month, 0).getDate()
    if(date < 14){
        startDate = year + '-' + month + '-' + "01"
        endDate = year + '-' + month + '-' + "14"
    }else{
        startDate = year + '-' + month + '-' + "15"
        endDate = year + '-' + month + '-' + endMonthDay
    }
    console.log("현재의 날짜는" + month + '-' + date + "이며, \n" + "정산기간은 " + startDate + "부터" + endDate + "까지입니다." )


    let baseTime = '';  // 정산기준 시간
    let baseDay;   // 날짜

    // api
    const request = function(){
        const pageSize = 5;

        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.result){
            case "200":
                const { item } = data;
                const { Data } = item;
                console.log('Data>', Data);
                
                render(Data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        console.log('GentleAppState.CurrentMastership', GentleAppState.CurrentMastership);

        // todo
        // IF ( 현재직급 == 다이아몬드 이상인 경우 ) {
        //     SearchSalesMasterAchievement = 1 로해서 Request 
        //     MasterShip 객체가 왔으면 뿌리면 되고 
        //     안왔으면 없다고 하면되고 }
        //  ELSE {
        //    SearchSalesMasterAchievement = 0 로해서 Request 
        //    SalseShop 객체가 왔으면 뿌리면 되고 
        //    안왔으면 없다고 하면 되고 
        //  } 
        const SearchSalesMasterAchievement = Number(GentleAppState.CurrentMastership) >= 4 ? "N" : "Y";

        startDate = "2022-01-01"; // test
        const param = {PageNo: 1, PageSize: 10, StartDate:startDate, EndDate:endDate, SearchSalesMasterAchievement};
        // proxy.request("global-mastership", param, onSuccess, onFailed );
        proxy.request("2025-mastership", param, onSuccess, onFailed );
    }

    GentleProxy.requestBaseTime(function(data){         
        console.log('해당부분에서 직급내역 데이트 출력', data)           
        baseTime = data;
        let arr = baseTime.split(' ');
        arr = arr[0].split('-');
        request();
    })

    const render = function(data){
        console.log('render>', data);

        const titleMe = GentleLang.translateService(language.bonus, language.bonus.type.MySales);
        const titlePosition = GentleLang.translate(GentleLang.type.Position);
        const titleLeft = GentleLang.translate(GentleLang.type.Left);
        const titleRight = GentleLang.translate(GentleLang.type.Right);
        const MastershipHistory = GentleLang.translateService(language.bonus, language.bonus.type.MastershipHistory);
        const titleButton = GentleLang.translateService(language.bonus, language.bonus.type.PositionPayMore);

        let Date, Mastership;
        let LeftPv= '', RightPv = '', BasicPv = '0', MinPv, Dealership, SalesMastership;
        let htmlSale = '';
        let mySales = '';

        console.log('GentleAppState.CurrentMastership', GentleAppState.CurrentMastership);

        if(Number(GentleAppState.CurrentMastership) >= 4) // 다이아몬드 이상
        {
            const { MastershipAchievementItems: items } = data; // array

            if(items.length > 0){
                const item = items[0];
                Date = item.Date;
                baseTime = GentleUtil.dateString(Date);
                Mastership = item.Mastership;
            }
            else
            {
                console.log('SalesMasterAchievementItems 무효함');
                let html = GentleLang.translateService(language.bonus, language.bonus.type.InvalidGrade)
                var bubble = Object.create( GentleComponentBubble );   
                bubble.createComponent({
                    html: html,
                });
                bubble.insert();
                return;
            }

        }else // 미만
        {
            const { SalesMasterAchievementItems } = data; // array

            if(SalesMasterAchievementItems.length > 0){
                const item = SalesMasterAchievementItems[0];
                Date = item.Date;
                baseTime = GentleUtil.dateString(Date);
                Mastership = item.Mastership;
            }
            else
            {
                console.log('SalesMasterAchievementItems 무효함');
                let html = GentleLang.translateService(language.bonus, language.bonus.type.InvalidGrade)
                var bubble = Object.create( GentleComponentBubble );   
                bubble.createComponent({
                    html: html,
                });
                bubble.insert();
                return;
            }
    
            if(SalesMasterAchievementItems)
            {
                const item = SalesMasterAchievementItems[0];
                // item.Date;
                // item.CustNo;
                LeftPv = item.LeftPv;
                RightPv = item.RightPv; 
                BasicPv = item.BasicPv;
                MinPv = item.MinPv;
                Dealership = item.Dealership;
                SalesMastership = item.Mastership;
            }

            // 좌우
            let left = GentleUtil.comma(LeftPv);
            let right = GentleUtil.comma(RightPv);

            if(SalesMasterAchievementItems){
                htmlSale = `
                <div class="flex-box-2 center">
                    <div>
                        <strong>${titleLeft}</strong>
                        <hr class="mt-8">
                        <strong><em>${left}</em> PV</strong>
                    </div>
                    <div>
                        <strong>${titleRight}</strong>
                        <hr class="mt-8">
                        <strong><em>${right}</em> PV</strong>
                    </div>
                </div>`;
            }

            // 본인매출
            let sales = BasicPv;
            sales = GentleUtil.comma(sales);
            sales = GentleLang.translate(GentleLang.type.CurrencyFormat2, {num: sales});

            mySales = `                    
            <div class="flex-box-2 space-beetween">
                <span>${titleMe}</span>
                <span>${sales}</span>
            </div>
            `;
        }


        // 직급 
        let position = GentleLang.mastershipType(Mastership);


        // 봇버블
        if(!simple)
        {
            const name = GentleAppState.custName;
            console.log('baseTime', baseTime);

            let arr = baseTime.split(' '); 
            arr = arr[0].split('.');
            baseDay = Number(arr[2]); // 수신한 데이터로 셋팅
            console.log('baseDay', baseDay);

            const html = baseDay > 15 ? 
            GentleLang.translateService(language.bonus, language.bonus.type.PositionDay31,{name,position})
            : GentleLang.translateService(language.bonus, language.bonus.type.PositionDay15,{name,position});            
            
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 
        {            
            let htmlButton = `
            <div class="gentle-button-group margin-zero">
                <div class="wide-button">
                    <button class="primary default">${titleButton}</button>        
                </div>
            </div>        
            `;
            if(simple) htmlButton = '';

            let html = `
            <div class="card-view">
                <div class="margin-container">
                    <h3>${MastershipHistory}</h3>
                    <span class="time-label">${GentleLang.translateService(language.bonus, language.bonus.type.BasedTimeMastership, {date:baseTime})}</span>
                    ${mySales}
                    <div class="flex-box-2 space-beetween">
                        <span>${titlePosition}</span>
                        <span><strong>${position}</strong></span>
                    </div>
                </div>
                <div class="account-box">
                    ${htmlSale}
                    ${htmlButton}
                </div>
            </div>            
            `;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("search");
                component.init($container);
                component.insert();
            }

            // bind
            {
                // const $date = component.find('.time-label');
                // GentleProxy.requestBaseTime(function(date){                    
                //     $date.html(GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date}));
                // })
            }

            // button
            if(!simple)
            {
                component.find('button').bind('click',function() {
                    console.log('더 많은 직급내역 보기');
                    var redirectUrl = GentleAppState.isPc ? language.url.pc.SeeMoreMastership : language.url.mobile.SeeMoreMastership;
                        GentleUtil.ssoOpen(redirectUrl);
                });
            }
        }

        // button
        if(!simple)
        {
            const text = GentleLang.translateService(language.bonus, language.bonus.type.ShowSales);

            const option = [
                {
                    isSecondary: true,
                    isCardWidth: true,
                    text: text,
                    user: 'user',
                    onClick: function () {
                        console.log('매출보기');
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }

        // quickReplay
        if(!simple)
        {
            const buttons = [
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.SponPay),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.SponPay),
                    onClick: function() {
                        console.log('후원수당');
                        // GentleServiceBonus.huwonBonus();
                    }
                },
                {
                    title: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.SponDetail),
                    onClick: function() {
                        console.log('후원수당 발생내역');
                        // GentleServiceBonus.huwonBonusOccurrence();
                    }
                },
                {
                    // send: false, 인텐트 처리
                    title: GentleLang.translateService(language.bonus, language.bonus.type.Income),
                    text: GentleLang.translateService(language.bonus, language.bonus.type.Income),
                    // onClick: function() {
                    //     console.log('수당내역');
                    //     GentleServiceBonus.main();
                    // }
                },
            ];
            var quickReply = Object.create( GentleComponentQuickReply);   
            quickReply.createComponent(buttons);
            quickReply.insert();
        }

        if(completed) {
            completed();
        }
        else{
            GentleUtil.timeStamp();
        }
    };
}

export default GentleServiceBonus;